export default __webpack_public_path__ + "static/media/2266_closed.5e5eccfd.jpg";